// officeUsers.js — usuarios de oficina que pueden usar el calendario interno
// (admin, coordinador_operaciones, atencion_cliente). Los técnicos no
// interactúan con esta funcionalidad. Copia frontend de
// netlify/functions/_officeUsers.js — el email es el identificador estable
// de cada persona (creadorId / participantes[].userId).
export const OFFICE_USERS = [
  { email: 'rafael.zapata@climatizacionzapata.es',    nombre: 'Rafael Zapata',    rol: 'admin' },
  { email: 'reyes.perez@climatizacionzapata.es',      nombre: 'Reyes Pérez',      rol: 'coordinador_operaciones' },
  { email: 'vanessa.escudero@climatizacionzapata.es', nombre: 'Vanessa Escudero', rol: 'atencion_cliente' },
];

export function findOfficeUser(email) {
  const e = (email || '').trim().toLowerCase();
  return OFFICE_USERS.find(u => u.email.toLowerCase() === e) || null;
}
